import { useCallback } from 'react';

import {
  FicheJudiciaireRequestDto,
  FicheJudiciaireViolationDtoFormFieldEnum,
  FicheJudiciaireWithMotifMefRequestDto,
  GardienFourriereControllerApi,
} from 'lib_api/lib/api/gen';

import { fetchFormViolations } from 'components/BaseForm/utils';
import { useApi } from 'hooks/ApiStoreContext';

import { FicheJudiciaireFormValues } from '../types';

export function ficheJudiciaireFormValuesToRequestWrapperDto(
  FicheJudiciaire: FicheJudiciaireFormValues,
  motifMefId: string | null,
): FicheJudiciaireWithMotifMefRequestDto {
  return {
    motifMefId: motifMefId,
    ficheJudiciaireRequestDto:
      ficheJudiciaireFormValuesToRequestDto(FicheJudiciaire),
  };
}

export function ficheJudiciaireFormValuesToRequestDto(
  formValues: FicheJudiciaireFormValues,
): FicheJudiciaireRequestDto {
  return {
    idCorrelationJuridiction:
      formValues.juridiction?.option?.idCorrelation || null,
    numeroParquet: formValues.numeroParquet || null,
    numeroPv: formValues.numeroPv || null,
    numeroIDJ: formValues.numeroIDJ || null,
    valeurJuridique: formValues.valeurJuridique || null,
  };
}

export function useValidateFicheJudiciaireField(
  motifMefId: string | null,
): (
  field: FicheJudiciaireViolationDtoFormFieldEnum,
  formValues: FicheJudiciaireFormValues,
) => Promise<void> {
  const { GardienFourriereControllerApi: gfController } = useApi();
  return useCallback(
    (
      field: FicheJudiciaireViolationDtoFormFieldEnum,
      formValues: FicheJudiciaireFormValues,
    ) => {
      return validateFicheJudiciaireField(
        field,
        formValues,
        gfController,
        motifMefId,
      );
    },
    [gfController, motifMefId],
  );
}

async function validateFicheJudiciaireField(
  field: FicheJudiciaireViolationDtoFormFieldEnum,
  formValues: FicheJudiciaireFormValues,
  gfController: GardienFourriereControllerApi,
  motifMefId: string | null,
): Promise<void> {
  return fetchFormViolations(
    () => {
      return gfController.validateFicheJudiciaireFieldUsingPOST(
        field,
        ficheJudiciaireFormValuesToRequestWrapperDto(formValues, motifMefId),
      );
    },
    violationResponse => {
      return violationResponse.ficheJudiciaireViolationDtoList;
    },
    violation => {
      return violation.message;
    },
  );
}
